import { Box, Flex, Grid, Text, Tooltip } from '@chakra-ui/react';
import { Badge, ButtonIcon } from '@morressier/alembic';
import {
  getRScoreBadgeVariant,
  AvgRScoreBadgeVariant,
  AvgRScoreCategory
} from 'src/utils/badgeVariants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBooks,
  faInfoCircle,
  faGlobe
} from '@fortawesome/pro-regular-svg-icons';

const AVG_R_SCORE_KEY = 'AverageRScore';

export interface ReviewerStatsRow {
  label: string;
  labelKey: string;
  value: string | number | null | undefined;
  globalValue?: string | number | null | undefined;
  tip?: string | null;
}

interface ReviewerStatsTableProps {
  rows: ReviewerStatsRow[] | null | undefined;
  globalLexiconConfig: undefined | boolean;
}

export const ReviewerStatsTable = ({
  rows,
  globalLexiconConfig
}: ReviewerStatsTableProps) => {
  if (!rows) {
    return null;
  }

  return (
    <Grid templateColumns="repeat(3, minmax(0, 1fr))" width="100%">
      {rows.map((item, index) => {
        const isAverageScore = item.labelKey === AVG_R_SCORE_KEY;

        const renderScore = (
          value: string | number | null | undefined,
          icon: React.ReactNode
        ) => {
          let variant: AvgRScoreBadgeVariant | undefined;
          let scoreLabel: AvgRScoreCategory | undefined;

          if (isAverageScore && value !== undefined && value !== null) {
            ({ variant, label: scoreLabel } = getRScoreBadgeVariant(
              value?.toString()
            ));
          }

          return (
            <Flex
              flex="1"
              alignItems="center"
              justifyContent="flex-end"
              gap={2}
              maxW={'max-content'}
            >
              {icon}

              {isAverageScore ? (
                <Badge variant={variant}>
                  {scoreLabel ? `${value} (${scoreLabel})` : value}
                </Badge>
              ) : (
                <Text
                  textStyle="textContext"
                  overflow="hidden"
                  textOverflow="ellipsis"
                  whiteSpace="nowrap"
                >
                  {value ?? '-'}
                </Text>
              )}
            </Flex>
          );
        };

        return (
          <Box
            key={`${item.labelKey}-${index}`}
            display="flex"
          
            paddingX={3}
            paddingY={2}
            minHeight="56px"
            flexDirection={'column'}
            borderWidth="1px"
            borderColor="gray.200"
          >
            {/* Label - 70% */}
            <Flex flex="0 0 70%" minW={0}  alignItems="center">
               <Text textStyle="headingItem" alignItems={''}>
                {item.label}
                {item.tip && (
                  <Tooltip
                    hasArrow
                    borderRadius={4}
                    placement="top"
                    shouldWrapChildren
                    label={item.tip}
                  >
                    <ButtonIcon
                      as="span"
                      size="regular"
                      ariaLabel="More information"
                      variant="primary"
                      icon={<FontAwesomeIcon icon={faInfoCircle} size="sm" />}
                    />
                  </Tooltip>
                )}
              </Text>
            </Flex>

            {/* Values - 30%, aligned to right */}
            <Flex
              flex="0 0 30%"
              minW={0}
              gap={2}
              flexWrap="wrap"
              mb={1}
             
            >
              {renderScore(item.value, <FontAwesomeIcon icon={faBooks} />)} 

              {(Boolean(item?.globalValue) || item?.globalValue==0) && globalLexiconConfig && (
                <>
                <Box color={'neutralPrimaryBorder'}>|</Box>
                  {renderScore(
                    item.globalValue,
                    <FontAwesomeIcon icon={faGlobe} />
                  )}
                </>
              )}
            </Flex>
          </Box>
        );
      })}
    </Grid>
  );
};
